import { Empregabilidade } from '../../types';

export const EMPREGABILIDADE: Empregabilidade[] = [
  {
    title: 'Carreira',
    descricao: 'Carreira',
    url: '/carreiras',
    linkExterno: false,
    dataElement: 'menu-carreiras',
  },
  {
    title: 'Singular',
    descricao: 'Singular',
    url: '/singular',
    linkExterno: false,
    dataElement: 'link_trilha-de-carreira',
  },
  {
    title: 'Encontre sua vaga',
    url: 'https://www.encontresuavaga.com.br/',
    descricao: 'Encontre sua vaga',
    linkExterno: true,
    dataElement: 'menu-encontre-sua-vaga',
  },
  {
    title: 'Mapeamento Socioemocional',
    url: '/mapeamento-socioemocional',
    descricao: 'Mapeamento Socioemocional',
    linkExterno: false,
    dataElement: 'menu-mapeamento-socioemocional',
  },
];
